export const LEADER_TEXT =
  'Leaders meet to consider routines to implement schoolwide.'
export const STAFF_TEXT =
  'Staff meets in small-groups to share key learnings from this unit.'
